const actions = {
	FETCH_PRODUCTS: 'FETCH_PRODUCTS',
	SET_PRODUCTS: 'SET_PRODUCTS',
	fetchProducts : () => ({
		type: actions.FETCH_PRODUCTS
	}),
};

export default actions;
